import Vue from 'vue';
import router from '@/router';

/* Bootstrap Plugin */
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue from 'bootstrap-vue';

/* Font Awesome Plugin */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* Notifications */
import Notifications from 'vue-notification';
import VueSweetalert2 from 'vue-sweetalert2';

/* Floating Action Buttons */
import VueFab from 'vue-float-action-button';

/* Google Analytics */
import VueAnalytics from 'vue-analytics';

/* Facebook Pixel Code */
import VueFacebookPixel from 'vue-analytics-facebook-pixel';

/* Google Tag Manager */
import VueGtm from 'vue-gtm';

/* Plugin Registration */
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueSweetalert2);
Vue.use(VueFab);


const isDevelopment = process.env.NODE_ENV === 'development';


Vue.use(VueAnalytics, {
  id: process.env.GA_ID,
  router,
  debug: {
    enabled: isDevelopment,
    sendHitTask: !isDevelopment,
  },
});


if (!isDevelopment) {
  /* Facebook Pixel Code Installation */
  !function(f,b,e,v,n,t,s)/* eslint-disable-line */
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?/* eslint-disable-line */
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};/* eslint-disable-line */
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';/* eslint-disable-line */
    n.queue=[];t=b.createElement(e);t.async=!0;/* eslint-disable-line */
    t.src=v;s=b.getElementsByTagName(e)[0];/* eslint-disable-line */
    s.parentNode.insertBefore(t,s)}(window, document,'script',/* eslint-disable-line */
    'https://connect.facebook.net/en_US/fbevents.js');/* eslint-disable-line */

  Vue.use(VueGtm, {
    id: process.env.GOOGLE_TAG_MANAGER_ID,
    vueRouter: router,
  });

  if (process.env.NODE_ENV === 'production') {
    Vue.use(VueFacebookPixel);
    Vue.analytics.fbq.init(process.env.FACEBOOK_PIXEL_ID);
    router.afterEach(() => {
      Vue.analytics.fbq.event('PageView');
    });
  }
}

/* Global Components */
Vue.component('font-awesome-icon', FontAwesomeIcon);



// WEBPACK FOOTER //
// ./src/start/plugins.js